import { BREAKPOINTS } from '../../model/model';
import { isDefined, isNotDefined } from '../../utils/util';

class nshopContent {
  constructor(options) {
    const _ = this;
    if (!options) return;
    _.option = $.extend({
      wrap: null,
      breakpoint: BREAKPOINTS,
      global: window,
      data : null
    }, options);
    _.global = (_.option.global) ? _.option.global : window;
  }

  init(obj) {
    const _ = this;
    // console.log( '# nshopContent.js init() _.option : ', _.option);
    if (isDefined(_.option.wrap) && _.option.wrap.length) _.setInstance();
    return _;
  }

  setInstance() {
    const _ = this;
    if(_.global.isTestServer() && _.option.device == 'ingame' ) return;

    // console.log( '# nshopContent.js : _.option.data : ', _.option.data);
    let tmpl_item = _.option.data.items.map( (item, i) => {

      const isGrade = item.grade ? `<i class="shop-grade-vip"></i>` : ``;
      const isPoint = item.point ? `<i class="shop-price-point"></i>` : ``;
      const isCoin = `<i class="shop-price-coin"></i>`;
      // const nshopUrl = _.option.device == 'launcher' ? (val.url.replace(/lineagenshop.plaync.com/i, 'launcher-lineagenshop.plaync.com')).replace(/rc./i, 'rc-') : item.url;

      return `
            ${(i == 4 || i == 8) ? `</div><div class="slick-item">` : ``}
            <section class="nshop__item">
                <a href="${item.url}"><span class="flag flag-${item.flag}"></span><dl><dd class="thumb"><img src="${item.thumbnail}" alert="${item.title}"></dd><dt>${item.title}</dt><dd class="price">${isGrade}${isPoint}${isCoin}<strong>${item.ncoin}</strong></dd></dl></a>
        </section>
      `;
    }).join('');

    let tmpl = `
      <header><h2><a href="${_.option.data.headerUrl}">${_.option.data.header}</a></h2></header>
      <article id="nshopRoll">
      <div class="slick-item">
        ${tmpl_item}
      </div>
      </article>
    `;

    _.option.wrap.append(tmpl);
    _.addEvent();
  }

  addEvent() {
    const _ = this;
      $('#nshopRoll').slick({
        dots: true,
        infinite: false,
        arrows: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 640,
            slidesToShow: 2
          }
        ]
      });

      $(window).resize(function() {
        $('#nshopRoll').slick('resize');
      });
    }

}

export default nshopContent;


// WEBPACK FOOTER //
// ./_src/js/main/content/NshopContent.js